import toTitleCase from './title-case.js';
import { translations } from '../data/translations.js';

export default class AtdValidate {
    static validateData(fields, validateList, language = 'en') {
        let noErrors = true;
        let errors = {};

        if(validateList.exists) {
            validateList.exists.forEach((field) => {
                if(!fields[field]) {
                    errors[field] = translations['missing_field'][language];
                    noErrors = false;
                }
            });
        }

        if(validateList.min_length) {
            Object.keys(validateList.min_length).forEach((field) => {
                if(fields[field].length < validateList.min_length[field]) {
                    if(fields[field].length > 0) {
                        errors[field] = translations['too_short'][language];
                    }
                    else {
                        errors[field] = translations['missing_field'][language];
                    }
                    noErrors = false;
                }
            });
        }

        if(validateList.max_length) {
            Object.keys(validateList.max_length).forEach((field) => {
                if(fields[field].length > validateList.max_length[field]) {
                    errors[field] = `${translations['too_long'][language]}: ${validateList.max_length[field]}`;
                    noErrors = false;
                }
            });
        }

        if(validateList.email) {
            validateList.email.forEach((field) => {
                if(!fields[field] || !AtdValidate.validateEmail(fields[field])) {
                    errors[field] = translations['valid_email'][language];
                    noErrors = false;
                }
            })
        }

        if(validateList.phone) {
            validateList.phone.forEach((field) => {
                if(!fields[field].length) {
                    return;
                }

                if(!fields[field] || !AtdValidate.validatePhone(fields[field])) {
                    errors[field] = translations['valid_phone'][language];
                    noErrors = false;
                }
            })
        }

        if(validateList.zip) {
            validateList.zip.forEach((field) => {
                if(!fields[field].length) {
                    return;
                }

                if(!fields[field] || !AtdValidate.validateZip(fields[field])) {
                    errors[field] = translations['valid_zip'][language];
                    noErrors = false;
                }
            })
        }

        if(validateList.not_empty) {
            validateList.not_empty.forEach((field) => {
                if(fields[field] && !fields[field].length) {
                    errors[field] = translations['select_one'][language];
                    noErrors = false;
                }
            });
        }

        if(validateList.conditional) {
            validateList.conditional.forEach((conditional) => {
                if(fields[conditional.field]) {
                    errors = Object.assign(errors, AtdValidate.validateConditionals(fields, conditional.required, language));
                    if(Object.keys(errors).length) {
                        noErrors = false;
                    }
                }
            });
        }

        if(validateList.selections) {
            if(!Object.keys(fields['selections']).length) {
                errors['selections'] = translations['select_one'][language];
                noErrors = false;
            }
        }

        Object.keys(errors).forEach((key) => {
            if(validateList.labels && validateList.labels[key]) {
                errors[validateList.labels[key]] = errors[key];
                delete errors[key];
            }
        });

        return noErrors || errors;
    }

    static validateConditionals(fields, conditionals, language) {
        let errors = {};
        Object.keys(conditionals).forEach((field) => {
            if(conditionals[field] === 'phone') {
                if(!AtdValidate.validatePhone(fields[field])) {
                    errors[field] = `${toTitleCase(field.replace('_', ' '))} ${translations['is_not_valid'][language]}.`;
                }
            }
            else if(conditionals[field] === 'email') {
                if(!AtdValidate.validateEmail(fields[field])) {
                    errors[field] = `${toTitleCase(field.replace('_', ' '))} ${translations['is_not_valid'][language]}.`;
                }
            }
            else {
                if(!fields[field]) {
                    errors[field] = translations['missing_field'][language];
                }
            }
        });

        return errors;
    }

    validateField(e) {
        if(!e && !e.target) {
            return;
        }

        let fieldName = e.target.getAttribute('id');
        if(this.reservationData.validate.exists.includes(fieldName)) {
            if(!this.reservationData[fieldName]) {
                this.errors[fieldName] = translations['missing_field']['en'];
            }
            else {
                delete this.reservationData[fieldName];
            }
        }

        if(this.reservationData.validate.email.includes(fieldName)) {
            if(!this.reservationData[fieldName] && !validateEmail(this.reservationData[fieldName])) {
                this.errors[fieldName] = translations['missing_field']['en'];
            }
            else {
                delete this.reservationData[fieldName];
            }
        }
    }

    static validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    static validatePhone(phone) {
        var re = /^[0-9]{10}$/;
        return re.test(phone);
    }

    static validateZip(zip) {
        var us = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
        var ca = /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z] [0-9][ABCEGHJ-NPRSTV-Z][0-9]$/;
        return us.test(zip) || ca.test(zip);
    }
}